{
	"paths": {
		"email": "E-mail",
		"password": "Hasło",
		"newPassword": "Nowe Hasło",
		"repeatPassword": "Powtórz Hasło",
		"username": "Nazwa użytkownika",
		"firstName": "Imię",
		"lastName": "Nazwisko",
		"emailOrUsername": "E-mail lub Nazwa użytkownika",
		"telephone": "Telefon"
	},
	"errors": {
		"at_least_numbers_with_value": "Musi zawierać co najmniej {{ minimum }} liczbę",
		"at_least_numbers_with_path": "{{ path }} musi zawierać co najmniej {{ minimum }} liczbę",
		"at_least_special_characters_with_value": "Musi zawierać co najmniej {{ minimum }} znaków specjalnych",
		"at_least_special_characters_with_path": "{{ path }} musi zawierać co najmniej {{ minimum }} znaków specjalnych",
		"only_letters_numbers_underscores": "Dozwolone są tylko litery, cyfry i podkreślenia"
	}
}
